/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_BeweegactiviteitenInputs */

const nl_nav_beweegactiviteiten = /** @type {(inputs: Nav_BeweegactiviteitenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beweegactiviteiten`)
};

/**

* @param {Nav_BeweegactiviteitenInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const nav_beweegactiviteiten = /** @type {((inputs?: Nav_BeweegactiviteitenInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_BeweegactiviteitenInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_nav_beweegactiviteiten(inputs)
});
export { nav_beweegactiviteiten as "nav.beweegactiviteiten" }